<template>
<div>

    <!-- Elementos de Contextualizacion -->
    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer bg-light header-text-variant="true" id="modal-redConceptos" size="xl" >
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>
        <div>
            <img src="recursos/img/RedConceptos@4x.png" class="img-fluid mx-auto d-none d-lg-block d-md-none" alt="">
            <img src="recursos/img/RedConceptosCel@4x.png" class="img-fluid mx-auto d-block d-lg-none" alt="">
        </div>
    </b-modal>
    <!-- Elementos de Contextualizacion -->

    <!-- Actividades -->
    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer header-text-variant="true" id="modal-resultadosActividades" size="lg" @hidden="onHidden">
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>

        <div class="row">
            <div class="col-lg-4 col-12">
                <img :src="imgURL" class="img-fluid d-flex mx-auto" alt="">
            </div>
            <div class="col-lg-8 col-12">
                <h3 class="mb-3 mt-xl-0 mt-lg-0 mt-3 text-left">{{tituloResultado}}</h3>
                <div v-html="descripcionResultado"></div>
            </div>
        </div>
    </b-modal>

    
    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer header-text-variant="true" id="modal-incorrectaAP" size="lg" >
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>
        <div class="row">
            <div class="col-lg-4 col-12">
                <img src="recursos/img/Incorrecto.png" class="img-fluid" alt="">
                
            </div>
            <div class="col-lg-8 col-12">
                <h3 class="mb-3 mt-xl-0 mt-lg-0 mt-3 text-left">¡Incorrecto!</h3>
            </div>
        </div>
    </b-modal>

    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer header-text-variant="true" id="modal-modalAPcorrecta1" size="lg" >
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>
        <div class="row">
            <div class="col-lg-4 col-12">
                <img src="recursos/img/Correcto.png" class="img-fluid" alt="">
            </div>
            <div class="col-lg-8 col-12">
                <h3 class="mb-3 mt-xl-0 mt-lg-0 mt-3 text-left">¡Muy bien!</h3>
                <p v-katex:auto>El total de camiones vendidos durante el semestre es de 30. De este total, hay 20 que funcionan a base de gasolina, es decir, 20 camiones de un total de 30 son a base de gasolina. Esto, como razón, se escribe:</p>
                <p v-katex:auto class="text-center">\(\frac{20}{30}\)</p>
                <p>Al simplificar, se obtiene:</p>
                <p v-katex:auto class="text-center">\(\frac{2}{3}\)</p>
                <p>De esta manera, la razón de camiones a base de gasolina es:</p>
                <p v-katex:auto class="text-center">\(\frac{2}{3}\)</p>
                <p>Esto significa que, de cada 3 camiones vendidos, 2 son a base de gasolina</p>
            </div>
        </div>
    </b-modal>

    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer header-text-variant="true" id="modal-modalAPcorrecta2" size="lg" >
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>
        <div class="row">
            <div class="col-lg-4 col-12">
                <img src="recursos/img/Correcto.png" class="img-fluid" alt="">
            </div>
            <div class="col-lg-8 col-12">
                <h3 class="mb-3 mt-xl-0 mt-lg-0 mt-3 text-left">¡Muy bien!</h3>
                <p v-katex:auto class="text-left">La razón de camiones a gasolina con respecto al total de camiones vendidos es \(\frac{20}{30}\).</p>
                <p v-katex:auto class="text-left">Si 𝑥 es la cantidad de automóviles eléctricos vendidos durante el semestre, entonces, la razón de automóviles eléctricos con respecto al total de automóviles vendidos es \(\frac{x}{150}\).</p>
                <p>Según la información dada, las ventas de automóviles eléctricos se encuentran en proporción a las ventas de camiones a gasolina; es decir, la razón de automóviles eléctricos es igual a la razón de camiones a gasolina:</p>
                <p v-katex:auto class="text-center">\(\frac{x}{150}=\frac{20}{30}\)</p>
                <p>Luego, al utilizar la propiedad del despeje de un extremo, se tiene:</p>
                <p v-katex:auto class="text-center">\(x=\frac{150\times20}{30}=100\)</p>
                <p>Lo anterior significa que un total de 100 automóviles eléctricos fueron vendidos durante el semestre.</p>
                <p>Ahora, como el total de automóviles vendidos durante el semestre es de 150 y, de estos, 100 son eléctricos, entonces el resto de los automóviles son híbridos:</p>
                <p class="text-center">150 − 100 = 50</p>
                <p>Así, la razón de automóviles híbridos con respecto al total de automóviles vendidos sería:</p>
                <p v-katex:auto class="text-center">\(\frac{50}{150}=\frac{1}{3}\)</p>
                <p>Esto quiere decir que 1 de cada 3 automóviles vendidos durante el semestre son híbridos.</p>
            </div>
        </div>
    </b-modal>

    <b-modal class="modal-bakdrop" :no-close-on-backdrop="true" hide-footer header-text-variant="true" id="modal-modalAPcorrecta3" size="lg" >
        <template v-slot:modal-header-close>
            <i class="icon-cerrar"></i>
        </template>
        <div class="row">
            <div class="col-lg-4 col-12">
                <img src="recursos/img/Correcto.png" class="img-fluid" alt="">
            </div>
            <div class="col-lg-8 col-12">
                <h3 class="mb-3 mt-xl-0 mt-lg-0 mt-3 text-left">¡Muy bien!</h3>
                <p>Total de ventas = Total de camiones vendidos + Total de automóviles vendidos = 30 +150 =180</p>
                <p>Camiones a diésel vendidos: 10</p>
                <p>x: porcentaje de las ventas que representan los 10 camiones a diésel</p>
                <p>Para encontrar este porcentaje, se hace una regla de tres simple directa:</p>
                <p>Ventas semestrales % de ventas<br>180 100<br>10 x</p>
                <p>La proporción queda como sigue:</p>
                <p v-katex:auto class="text-center">\(\frac{180}{10}=\frac{100}{x}\)</p>
                <p>Al aplicar la propiedad del despeje de un extremo, se llega a lo siguiente:</p>
                <p v-katex:auto class="text-center">\(x=\frac{10\times100}{180}=\frac{100}{180}=5.5\)</p>
                <p>Así, el 5.5 % del total de las ventas representan las ventas de camiones a diésel.</p>
            </div>
        </div>
    </b-modal>
    <!-- Actividades -->
</div>
</template>

<script>
export default {
    name: 'Modales',
    props: {
        tituloResultado: {
            type: String
        },
        descripcionResultado: {
            type: String
        },
        descripcion02: {
            type: String
        },
        imgURL: {
            type: String
        }
    },

    data: function(){
        return{       
        };
    },

    methods: {
       
        onHidden () {
         location.reload();
        },

        passSlide () {
            this.$emit('childToParent', true)
        }
    }
    
}
</script>